<template>
  <div class="event">
    <v-app id="event">
      <v-content v-if="item">
        <v-carousel 
          hide-delimiters 
          show-arrows-on-hover 
          cycle  v-if="extendy"
          height="400" 
          class="hidden-sm-and-down">
          <v-carousel-item 
            :src="getFirstImage(item.eventImages)" 
            v-if="getFirstImage(item.eventImages)">        
          </v-carousel-item>
          <v-carousel-item 
            :src="getSecondImage(item.eventImages)" 
            v-if="getSecondImage(item.eventImages)">        
          </v-carousel-item>
          <v-carousel-item 
            :src="getThirdImage(item.eventImages)" 
            v-if="getThirdImage(item.eventImages)">        
          </v-carousel-item>
          <v-carousel-item 
            :src="getFourthImage(item.eventImages)" 
            v-if="getFourthImage(item.eventImages)">        
          </v-carousel-item>
          <span>
            <b class="mapit">
              <mapdirection />
              <v-bottom-sheet v-model="sheet1" inset>
                <template v-slot:activator="{ on }">
                  <v-btn fab small rounded color="grey lighten-1" 
                    style="left: 85px; position: relative; bottom: 2px;" 
                    v-on="on">
                    <v-icon>
                      mdi-share
                    </v-icon>
                  </v-btn>
                </template>
                <v-sheet class="text-center" height="100px">
                  <div class="label"><b>Share This Event:</b></div>
                    <social-sharing :url="'https://vergeo-21ffc.firebaseapp.com/event/'+ item.slug" :title="item.name" :description="item.description" quote="This Event is from Convergeo click here to view.." hashtags="convergeo events" twitter-user="Convergeo" inline-template>
                      <div>
                        <network network="facebook">
                          <a href="#"><img src="@/assets/facebook.jpg" alt="Facebook" width="30" /> <v-divider class="mx-4" vertical></v-divider></a>
                        </network>
                        <network network="linkedin">
                          <a href="#"><img src="@/assets/linkedIn.png" alt="linkedin" width="30" /> <v-divider class="mx-4" vertical></v-divider></a>
                        </network>
                        <network network="pinterest">
                          <a href="#"><img src="@/assets/pinterest.jpg" alt="pinterest" width="30" /> <v-divider class="mx-4" vertical></v-divider></a>
                        </network>
                        <network network="skype">
                          <a href="#"><img src="@/assets/skype.jpg" alt="skype" width="30" /> <v-divider class="mx-4" vertical></v-divider></a>
                        </network>
                        <network network="twitter">
                          <a href="#"><img src="@/assets/twitter.jpg" alt="Twitter" width="30" /> <v-divider class="mx-4" vertical></v-divider></a>
                        </network>
                        <network network="whatsapp">
                          <a href="#"><img src="@/assets/whatsapp.jpg" alt="whatsapp" width="30" /></a>
                        </network> 
                      </div>
                    </social-sharing>
                </v-sheet>
              </v-bottom-sheet>
            </b>
            <v-card-title class="align-end fill-height white--text ml-10 main-title">
              <b class="main-title-text">{{ item.name | capitalize }}</b>
            </v-card-title>
            <v-card-title class="align-end fill-height white--text ml-10 title">
                <b class="title-text">{{ item.venue }}, {{ item.town_code }}</b>
            </v-card-title>
            <v-card-title class="align-end fill-height white--text crumb">
              <router-link to="/">Home</router-link>
              <v-icon>mdi-forward</v-icon>
              <router-link :to="'/events/'+ item.Cat_slug">
                {{ item.Cat_slug | capitalize}}
              </router-link>
              <v-icon>mdi-forward</v-icon>
              {{  item.name | capitalize }}
            </v-card-title>
            <v-card-title class="align-end fill-height white--text  type">
              <span class="title-text"><b>{{  item.Cat_slug }}</b></span>
            </v-card-title>
            <v-card-title class="align-end fill-height white--text  date">
              <span class="subtitle-1">{{ item.date }} {{ item.SubCat_slug}}</span>
            </v-card-title>
            <v-card-title class="align-end fill-height white--text  time">
              <span class="subtitle-2">{{ item.s_time }}-{{ item.e_time }}</span>
            </v-card-title>
          </span>
        </v-carousel>
        <v-carousel 
          hide-delimiters 
          show-arrows-on-hover 
          cycle v-else
          height="200" 
          class="hidden-sm-and-down">
          <v-carousel-item 
            :src="getFirstImage(item.eventImages)" 
            v-if="getFirstImage(item.eventImages)">        
          </v-carousel-item>
          <span>
            <v-card-title class="align-end fill-height white--text ml-10 main-title">
              <b class="main-title-text">
                {{ item.name | capitalize }}
              </b>
            </v-card-title>
            <v-card-title class="align-end fill-height white--text ml-10 title">
              <b class="title-text">
                {{ item.venue }}, {{ item.town_code }}
              </b>
            </v-card-title>
            <v-card-title class="align-end fill-height white--text crumb">
              <router-link to="/">Home</router-link>
              <v-icon>mdi-forward</v-icon>
              <router-link :to="'/events/'+ item.Cat_slug">
                {{ item.Cat_slug | capitalize}}
              </router-link>
              <v-icon>mdi-forward</v-icon>
              {{  item.name | capitalize }}
            </v-card-title>
          </span>
        </v-carousel>
        <v-carousel 
          hide-delimiters 
          show-arrows-on-hover 
          cycle 
          height="210" 
          class="hidden-md-and-up">
          <v-carousel-item 
            :src="getFirstImage(item.eventImages)" 
            v-if="getFirstImage(item.eventImages)">        
          </v-carousel-item>
          <v-carousel-item 
            :src="getSecondImage(item.eventImages)" 
            v-if="getSecondImage(item.eventImages)">        
          </v-carousel-item>
          <v-carousel-item 
            :src="getThirdImage(item.eventImages)" 
            v-if="getThirdImage(item.eventImages)">        
          </v-carousel-item>
          <v-carousel-item 
            :src="getFourthImage(item.eventImages)" 
            v-if="getFourthImage(item.eventImages)">        
          </v-carousel-item>
          <span>
            <v-card-title class="mapit-mobile">
              <mapdirection />
            </v-card-title>
            <v-card-title 
              class="align-end fill-height white--text ml-10 main-title-mobile">
              <b class="main-title-text-mobile">
                {{ item.name | capitalize }}
              </b>
              <v-bottom-sheet v-model="sheet" inset>
                <template v-slot:activator="{ on }">
                  <v-icon v-on="on" 
                    style="left: 85px; position: relative; bottom: 2px;">
                    mdi-share-variant
                  </v-icon>
                </template>
                <v-sheet class="text-center" height="80px">
                  <div class="label"><b>Share This Event:</b></div>
                  <social-sharing :url="'https://vergeo-21ffc.firebaseapp.com/event'+ item.slug" :title="item.name" :description="item.description" quote="This Event is on Convergeo click here to view.." hashtags="convergeo events" twitter-user="Convergeo" inline-template>
                    <div>
                      <network network="facebook">
                        <a href="#"><img src="@/assets/facebook.jpg" alt="Facebook" width="30" /></a>
                      </network> <v-divider class="mx-4" vertical></v-divider>
                      <network network="linkedin">
                        <a href="#"><img src="@/assets/linkedIn.png" alt="linkedin" width="30" /></a>
                      </network> <v-divider class="mx-4" vertical></v-divider>
                      <network network="pinterest">
                        <a href="#"><img src="@/assets/pinterest.jpg" alt="pinterest" width="30" /></a>
                      </network> <v-divider class="mx-4" vertical></v-divider>
                      <network network="skype">
                        <a href="#"><img src="@/assets/skype.jpg" alt="skype" width="30" /></a>
                      </network> <v-divider class="mx-4" vertical></v-divider>
                      <network network="twitter">
                        <a href="#"><img src="@/assets/twitter.jpg" alt="Twitter" width="30" /></a>
                      </network> <v-divider class="mx-4" vertical></v-divider>
                      <network network="whatsapp">
                        <a href="#"><img src="@/assets/whatsapp.jpg" alt="whatsapp" width="30" /></a>
                      </network> 
                    </div>
                  </social-sharing>
                </v-sheet>
              </v-bottom-sheet>
            </v-card-title>
            <v-card-title class="align-end fill-height white--text ml-10 title-mobile">
                <b class="title-text-mobile">
                  {{ item.venue }}, {{ item.town_code }}
                </b>
            </v-card-title>
            <v-card-title class="align-end fill-height white--text crumb-mobile">
              <router-link to="/">Home</router-link>
              <v-icon small style="margin-bottom: 7px">mdi-forward</v-icon>
              <router-link :to="'/events/'+ item.Cat_slug">
                {{ item.Cat_slug | capitalize}}
              </router-link>
            </v-card-title>
            <v-card-title class="align-end fill-height white--text type-mobile">
              <span class="title-text"><b>{{  item.Cat_slug }}</b></span>
            </v-card-title>
            <v-card-title class="align-end fill-height white--text date-mobile">
              <span class="subtitle-1">{{ item.date }} {{ item.SubCat_slug}}</span>
            </v-card-title>
            <v-card-title class="align-end fill-height white--text time-mobile">
              <span class="subtitle-2">{{ item.s_time }}-{{ item.e_time }}</span><br>
            </v-card-title>
          </span>
        </v-carousel>
        <v-tabs dark background-color="indigo lighten-4" show-arrows>
          <b class="hidden-sm-and-down" v-if="extendy" @click="open_viewer">
            <v-icon color="grey darken-3" style="margin-top: 10px; ">
              mdi-arrow-down-drop-circle
            </v-icon>
          </b>
          <b class="hidden-sm-and-down" v-else @click="close_viewer">
          <v-icon color="grey darken-3" style="margin-top: 10px; ">
            mdi-arrow-up-drop-circle
          </v-icon>
        </b>
          <v-tabs-slider color="black"></v-tabs-slider>
          <v-tab>
            <b class="label" @click="open_viewer">Details</b>
          </v-tab><!--IF APPLICABLE -->
          <v-tab>
            <b class="label" @click="open_viewer">Artists</b>
          </v-tab><!--IF APPLICABLE -->
          <v-tab>
            <b class="label" @click="open_viewer">Tickets</b>
          </v-tab><!--IF APPLICABLE -->
          <v-tab>
            <b class="label" @click="open_viewer">Clients</b>
          </v-tab>
          <v-tab>
            <b class="label" @click="open_viewer">Comments(20)</b>
          </v-tab>
          <v-tab>
            <b class="label" @click="open_viewer">About us</b>
          </v-tab>
          <v-tab-item>
            <v-container fluid fill-height>
              <span v-html="item.description"></span>
              The clicking of the tabs must shrink the carousel
            </v-container>
          </v-tab-item>
          <v-tab-item>
            <v-container fluid fill-height>
              {{ item.s_time }}This displays the event artists with their Avatar images plus a few hype commentaries
            </v-container>
          </v-tab-item>
          <v-tab-item>
            <v-container fluid fill-height>
              {{ item.trans_deliv }}This displays the tickets that are been sold for the event with an add to cart(VIP, standard, inner circle, etc).
            </v-container>
          </v-tab-item>
          <v-tab-item>
            <v-container fluid fill-height>
              {{ item.client }} This Shows the Client and the partners and sponsors of the event. 
            </v-container>
          </v-tab-item>
          <v-tab-item>
            <v-container fluid fill-height>
              This Shows the Comments made by the potential people to visit the event as well as the likes and dislikes. 
            </v-container>
          </v-tab-item>
          <v-tab-item>
            <v-container fluid fill-height>
              The upper of the about us shows the contact inform for the event
              <b>This gives the about us of the company and can be activated by the client.</b>
            </v-container>
          </v-tab-item>
        </v-tabs>
      </v-content>
      <generalfab />
    </v-app>
  </div>
</template>

<script>
  import Vue from 'vue'
  import {fb, db} from '@/firebase'
  import SocialSharing from 'vue-social-sharing'
  Vue.use(SocialSharing)
  import mapdirection from '@/components/Client/map.vue' 
  export default {
    data: () => ({
      sheet: false,
      sheet1: false,
      item: null,
      extendy: true,
      user: null,
      comments: {
        event_id: '',
        event_slug: '',
        event_comment: '',
        user_id: '',
        client_id: '',
        user_name: ''
      },
      commento: [],
      likeo: [],
      likes: {
        event_id: '',
        event_slug: '',
        event_like: '',
        user_id: ''
      },
      quantityNumber: 0,
      quantityValue: null,
      index: null,
      dialog: false,
      dialog1: false
    }),

    watch: {
      dialog (val) {
        val || this.close()
      }
    },

    methods: {
      getFirstImage(eventImages){
        return eventImages[0]
      },
      getSecondImage(eventImages){
        return eventImages[1]
      },
      getThirdImage(eventImages){
        return eventImages[2]
      },
      getFourthImage(eventImages){
        return eventImages[3]
      },
      open_viewer(){
        this.extendy = false
      },
      close_viewer(){
        this.extendy = true
      },
      addNew(){
        this.reset()
        this.dialog = true
      },
      back(){
        this.$router.go(-1)
      },
      likeSum(){
        return this.likeo.reduce((prev,cur) => prev + cur.event_like,0)
      },
      reset(){
        this.likes = {
          event_id: '',
          event_slug: '',
          event_rating: '',
          user_id: ''
        }
        this.comments = {
          event_id: '',
          event_slug: '',
          event_comment: '',
          client_slug: '',
          user_name: '',
          user_id: ''
        }  
      },

      addQuantity(){
        if (this.quantityNumber>=0 && this.quantityNumber<= this.item.quantity-2){
            this.quantityNumber++
        }
      },
      subtractQuantity(){
          if (this.quantityNumber>0){
              this.quantityNumber--
          }
      },
      addToEventCart(){
        this.quantityValue = this.quantityNumber
        this.total = ((this.quantityValue)*(this.item.price))
        // db.collection('products').doc(this.item.id).update({
        //     quantity: ((this.item.quantity)-(this.quantityValue))
        // })
        // USE THIS IN THE CHECKOUT INSTEAD
        db.collection('cartitems').add({
            event_name: this.item.name,
            event_image: this.item.eventImages,
            event_price: this.item.price,
            client_name: this.item.client,
            client_town: this.item.town_code,
            event_quantity: this.quantityValue,
            event_total: this.total,
            event_id: this.item.id,
            user: fb.auth().currentUser.uid
        }).then(() => {
        /* eslint-disable */
        Toast.fire({
          type: 'success',
          title: 'event added to cart'
        })
        }).catch(err => {
            console.log(err);
        })
        /* eslint-enable */
      },
      addEventComments(){
        db.collection('comments').add({
            event_id: this.item.id,
            event_slug: this.item.slug,
            client_slug: this.item.client,
            user_name: this.user.name,
            event_comment: this.comments.event_comment,
            user: fb.auth().currentUser.uid
        }).then(() => {
        /* eslint-disable */
          Toast.fire({
            type: 'success',
            title: 'Review Successful!'
          })
          this.close()
        }).catch(err => {
          console.log(err);
        })
        /* eslint-enable */
      },
      addEventLike(){
        db.collection('likes').add({
          event_id: this.item.id,
          event_slug: this.item.slug,
          event_like: this.likes.event_like,
          user: fb.auth().currentUser.uid
        }).then(() => {
        /* eslint-disable */
          Toast.fire({
            type: 'success',
            title: 'Review Successful!'
          })
          this.close()
        }).catch(err => {
          /* eslint-disable */
          console.log(err);
          /* eslint-enable */
        }) 
      },
      updateEventLike(){
        db.collection('likes').doc(this.item.id).update({
          quantity: ((this.item.quantity)-(this.quantityValue))
        })
      },
      close () {
        this.dialog = false
      }
    },
    components: {
      mapdirection
    },
    
    created(){
      //get item data 
      let ref = db.collection('events')
      .where('slug', '==', this.$route.params.slug)
      ref.get().then(snapshot => {
          snapshot.forEach(doc => {
            this.item = doc.data()
            this.item.id = doc.id
          })
      })

      db.collection('comments')
      .where('event_slug','==',this.$route.params.slug).get()
      .then(snapshot =>{
        snapshot.forEach(doc =>{
          let comment = doc.data()
          comment.id =  doc.id
          this.commento.push(comment) 
        })
      })

      db.collection('likes')
      .where('event_slug','==',this.$route.params.slug).get()
      .then(snapshot =>{
        snapshot.forEach(doc =>{
          let like = doc.data()
          like.id =  doc.id
          this.likeo.push(like) 
        })
      })

      //get current user
      db.collection('user')
      .where('user_id','==',fb.auth().currentUser.uid).get()
      .then(snapshot=>{
        snapshot.forEach(doc => {
          this.user =doc.data(),
          this.user.id = doc.id//
        })
      })
    },
  }
</script>

<style scoped>
  .mapit {
    position: absolute;
    z-index: +10;
    bottom: 300px;
    right: 5%;
    pointer-events: auto;
  }
  .type {
    position: absolute;
    bottom: 250px;
    right: 70px;
  }
  .date {
    position: absolute;
    bottom: 220px;
    right: 70px;
  }
  .time {
    position: absolute;
    bottom:200px;
    right: 70px;
  }
  .crumb {
    position: absolute;
    top: -5px;
    left: 25px;
    font-size: 25px 
  }
  .main-title {
    position: absolute;
    bottom: 90px;
    left: -15px;
  }
  .title {
    position: absolute;
    bottom: 20px;
    left: -15px;
  }
  .main-title-text {
    font-size: 35px;
  }
  .title-text {
    font-size: 25px;
  }
  .left {
    float: right;
  }
</style>

<style scoped>
  .mapit-mobile {
    position: absolute;
    top: 2px;
    z-index: +10;
    right: 2px;
    pointer-events: auto;
  }
  .type-mobile {
    position: absolute;
    bottom: 120px;
    right: 2px;
  }
  .date-mobile {
    position: absolute;
    bottom: 100px;
    right: 2px;
  }
  .time-mobile {
    position: absolute;
    bottom: 80px;
    right: 2px;
  }
  .main-title-mobile {
    position: absolute;
    top: -20px;
    left: -40px;
  }
  .title-mobile {
    position: absolute;
    top: 1px;
    left: -40px;
  }
  .crumb-mobile {
    position: absolute;
    top: 20px;
    font-size: 17px;
  }
  .main-title-text-mobile {
    font-size: 25px;
  }
  .title-text-mobile {
    font-size: 20px;
  }
  .left {
    float: right;
  }
</style>
